import React from 'react'
import { Layout } from '@surecompanies/core_components'
import Page from 'layouts/Page'
import PageWrapper from 'enrollment-platform/PageWrapper'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { FINANCE_PATH } from '../../constants'
import PaymentBatchUpdateUpload from '../../components/PaymentBatchUpdate/PaymentBatchUpdateUpload'

const { Content } = Layout

export default function PaymentBatchUpdatePage() {
  return (
    <PageWrapper>
      <Page
        title="Primary Payment Method Batch Update"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Finance', path: FINANCE_PATH },
              { title: 'Primary Payment Method Batch Update' },
            ]}
          />
        }
      >
        <Layout style={{ backgroundColor: '#f6f9fc' }}>
          <Content
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              padding: '24px',
            }}
          >
            <PaymentBatchUpdateUpload />
          </Content>
        </Layout>
      </Page>
    </PageWrapper>
  )
}
